import { orgQueryKeys } from '@/config/queryKeys';
import { getOrganization } from '@/services/organizations';
import { FullLoading } from '@components/index';
import { useQuery } from '@tanstack/react-query';
import { createLazyFileRoute } from '@tanstack/react-router';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrganizationDetailsEdit } from '../../pages/Organizations/components/OrganizationDetailsEdit';

export const Route = createLazyFileRoute('/organizations/$orgId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const { t } = useTranslation('orgs');

  const {
    data: org,
    isPending,
    error,
  } = useQuery({
    enabled: !!orgId,
    queryKey: orgQueryKeys.detail(orgId),
    queryFn: () => getOrganization(orgId),
  });

  const orgFormValues = useMemo(
    () =>
      org
        ? {
            name: org.name ?? '',
            address: org.address ?? '',
            alias: org.alias ?? '',
            domain: org.email_domain ?? '',
            primaryContact: {
              firstName: org.primary_contact?.first_name ?? '',
              lastName: org.primary_contact?.last_name ?? '',
              email: org.primary_contact?.email ?? '',
              phone: org.primary_contact?.phone ?? '',
            },
            itContact: {
              firstName: org.it_contact?.first_name ?? '',
              lastName: org.it_contact?.last_name ?? '',
              email: org.it_contact?.email ?? '',
              phone: org.it_contact?.phone ?? '',
            },
            subscription: {
              active: org.subscription?.is_active ?? false,
              expiration: org.subscription?.expires_at ?? '',
            },
          }
        : null,
    [org],
  );

  if (isPending) return <FullLoading addEllipsis label={t('org_loading')} />;

  if (error) return t('refetch_error', { message: error.message });
  if (!orgFormValues) return t('org_not_found');

  return <OrganizationDetailsEdit orgId={orgId} initialValues={orgFormValues} />;
}
